/**
 * ??????? API ???? ????.
 * axios ??????????(src/api/index.js)?????????? ????????,
 * ??? ????? index.js ??????????????? ???????? Authorization ???????????????.
 *
 * ????? ???: axios ??????????????? 401 ?????? ??? ????, ?????????????????? ???.
 */
import api from './index'

/* ================================================================
 * ??????? API
 * ================================================================ */

/**
 * ???????? ?? ???? (??????????+ ?????????).
 * HQ ???????????, ??????????????? ?????????????????????.
 *
 * @param {Object} params - { keyword, status, startDate, endDate, page, size }
 * @returns {Promise} { code, message, data: { items, total, page, size, totalPages } }
 */
export function getAppraisalList(params) {
  return api.get('/api/v1/appraisal', { params })
}

/**
 * ???????? ????? ????.
 * ????? ??? + ????? ????? + ???????????? ????? ??????????????.
 *
 * @param {string} appraisalBookingCode - ?????????????
 * @returns {Promise} { code, message, data: { ...????????, ...????????, lots: [...] } }
 */
export function getAppraisalDetail(appraisalBookingCode) {
  return api.get(`/api/v1/appraisal/${appraisalBookingCode}`)
}

/**
 * ??????? ????? (user_spot_lot INSERT).
 * ???????????????? ????????? ??? ??????? status?? 'ING'?????????
 *
 * @param {string} appraisalBookingCode - ?????????????
 * @param {Object} data - { spotType, appraisalPurity, appraisalWeight, completeWeight, currency, appraisalPrice }
 * @returns {Promise} ??????????????? ????? ?????
 */
export function createAppraisalLot(appraisalBookingCode, data) {
  return api.post(`/api/v1/appraisal/${appraisalBookingCode}/lot`, data)
}

/**
 * 지점 품목별 측정 저장 (appraisal_result, step=1). 동일 현물구분 기존 행 삭제 후 재등록.
 *
 * @param {string} appraisalBookingCode
 * @param {Object} body - { spotType: 'GOLD'|'SILVER', lines: [{ appraisalItemCode, checkWeight, checkPercent? }] }
 */
export function saveBranchAppraisalItemResults(appraisalBookingCode, body) {
  return api.post(`/api/v1/appraisal/${appraisalBookingCode}/branch-item-results`, body)
}

/**
 * 지점 감정 완료: 금·은 품목별 측정을 한 번에 저장 (ING → COMPLETE).
 *
 * @param {string} appraisalBookingCode
 * @param {Object} body - { goldLines, silverLines: [{ appraisalItemCode, checkWeight, checkPercent? }] }
 */
export function completeBranchAppraisal(appraisalBookingCode, body) {
  return api.post(`/api/v1/appraisal/${appraisalBookingCode}/branch-appraisal-complete`, body)
}

/**
 * 본사 검품 완료: appraisal_result step=9 및 hp_yn=Y. 감정완료(COMPLETE) 예약만.
 *
 * @param {string} appraisalBookingCode
 * @param {Object} body - { goldLines, silverLines } (지점 완료 API와 동일)
 */
export function completeHqAppraisal(appraisalBookingCode, body) {
  return api.post(`/api/v1/appraisal/${appraisalBookingCode}/hq-appraisal-complete`, body)
}
